import { Component, output } from '@angular/core';
import { Alert, LoadingSpinner, Button } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-request-created-alert',
  imports: [Alert, LoadingSpinner, Button, TranslocoPipe],
  templateUrl: './parse-request-created-alert.html',
})
export class ParseRequestCreatedAlert {
  clickGoToDetails = output();
  clickHide = output();
}
